import { useRef } from 'react'

import { EMPTY_ARRAY } from 'constants/commonConstans'

import type { IFieldConfig } from './types'

const mergeConfigs = (
  ...[initial, ...configs]: [IFieldConfig, ...Partial<IFieldConfig>[]]
): IFieldConfig =>
  configs.reduce<IFieldConfig>(
    (acc, cur) => ({
      ...acc,
      ...cur,
      disabled: acc.disabled || cur?.disabled,
      hidden: acc.hidden || cur?.hidden,
      readOnly: acc.readOnly || cur?.readOnly,
      props: { ...acc.props, ...(cur?.props ?? {}) } as IFieldConfig['props'],
    }),
    initial,
  ) as IFieldConfig

export const useConfig = (initialConfig: IFieldConfig, configs: IFieldConfig[] = EMPTY_ARRAY) => {
  const useConfigs = useRef(initialConfig.useConfigs || EMPTY_ARRAY)
  let config = initialConfig
  for (const useConfig of useConfigs.current) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const part = useConfig(initialConfig, configs)
    config = mergeConfigs(config, part as Partial<IFieldConfig>)
  }
  return config
}
